import { Col as AntdCol } from 'antd';
import PropTypes from 'prop-types';

const Col = ({ lg, md, sm, span, className, children }) => (
  <AntdCol lg={lg} md={md} sm={sm} span={span} className={className}>
    {children}
  </AntdCol>
);

Col.defaultProps = {
  sm: null,
  md: null,
  lg: null,
  span: null,
  children: null,
  className: null,
};

const sizeType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.shape({ span: PropTypes.number.isRequired, order: PropTypes.number.isRequired }),
]);

Col.propTypes = {
  lg: sizeType,
  md: sizeType,
  sm: sizeType,
  span: PropTypes.number,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Col;
